import React from 'react';

import { L10nPhone } from '@travel/i18n';
import { Fax } from '@travel/icons/ui';
import type { ProviderInformation } from '@travel/traveler-core/types/providerInformation';
import { isEmptyArray } from '@travel/utils';

import { Translate } from '../../../../core/translate';

import styles from './basicInformation.module.scss';

export default function FaxInfo(props: { provider: ProviderInformation; isMobile: boolean }) {
  const { provider, isMobile } = props;
  if (isEmptyArray(provider.contact?.faxInfo)) {
    return null;
  }

  return (
    <div className={styles.rowItem}>
      <div className={styles.leftContent}>
        {isMobile && <Translate id="Provider_Info.Basic_Info.Hotel_Info.Fax" />}
        {!isMobile && <Fax size={16} />}
      </div>
      <div className={styles.rightContent}>
        {provider.contact.faxInfo.map((fax, index) => (
          <React.Fragment key={fax}>
            {index > 0 && ', '}
            <L10nPhone value={fax} country="JPN" />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
